import { defineStore } from 'pinia';
import { useIndexStore } from './IndexStore';
import AirManagementService from '@/service/AirManagementService';

export const useAirManagementStore = defineStore('airManagementStore', {
  state: () => ({
    airs: [],
    isLoading: false,
    flights: [],
    flightById: {}
  }),
  getters: {
    doLoading: (state) => state.isLoading,
    selectListFlightById: (state) => state.flightById,
    getUrlUploadFileAir: () => {
      const Service = new AirManagementService();
      return Service.getUrlUploadFileAir();
    }
  },

  actions: {
    async getListAir() {
      const Service = new AirManagementService();
      const res = await Service.getListAir();
      this.airs = res?.data;
      return res?.data;
    },

    getAirportDetail(airportCode) {
      return this.airs?.find((airport) => airport.airportCode === airportCode);
    },

    async findFareRequest(body) {
      const Service = new AirManagementService();
      const res = await Service.getFareRequest(body);
      return res?.data;
    },

    async updateAirStatus(payload) {
      const Service = new AirManagementService();
      const res = await Service.updateAirStatus(payload);
      return res?.data;
    },

    async updateAirport(payload) {
      const Service = new AirManagementService();
      const res = await Service.updateAirport(payload);
      return res?.data;
    },

    deleteAirport(id) {
      const Service = new AirManagementService();
      return Service.deleteAirport(id);
    },

    async syncData() {
      const Service = new AirManagementService();
      try {
        this.isLoading = true;
        const res = await Service.syncData();
        if (res) {
          this.isLoading = false;
          return res?.data;
        }
      } catch (e) {
        this.isLoading = false;
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },

    async getListFlight() {
      const service = new AirManagementService();
      try {
        const res = await service.getListFlight();
        if (res) {
          this.flights = res?.data;
        }
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },

    async addFlight(payload) {
      const service = new AirManagementService();
      try {
        await service.addFlight(payload);
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },

    async deleteFlight(sk) {
      const service = new AirManagementService();
      try {
        await service.deleteFlight(sk);
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },

    async getFlightById(sk) {
      const service = new AirManagementService();
      try {
        const res = await service.getFlightById(sk);
        this.flightById = res?.data;
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },

    async updateFlightStatus(sk, status) {
      const service = new AirManagementService();
      try {
        await service.updateFlightStatus(sk, status);
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },

    async getFlightSeat(payload) {
      const Service = new AirManagementService();
      const res = await Service.getFlightSeat(payload);
      return res?.data;
    },

    async getListTax() {
      const service = new AirManagementService();
      try {
        const res = await service.getListTax();
        if (res) {
          return res.data;
        }
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },

    async addTax(payload) {
      const service = new AirManagementService();
      try {
        await service.addTax(payload);
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },

    async updateTax(payload) {
      const service = new AirManagementService();
      try {
        await service.updateTax(payload);
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },

    async removeTax(id) {
      const service = new AirManagementService();
      try {
        await service.removeTax(id);
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },

    importFileAir(payload) {
      const Service = new AirManagementService();
      return Service.importFileAir(payload);
    },

    getPreviewAirByFileName(fileName) {
      const Service = new AirManagementService();
      return Service.getPreviewAirByFileName(fileName);
    },

    revertAirVersion(fileName) {
      const Service = new AirManagementService();
      return Service.revertAirVersion(fileName);
    }
  }
});
